import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { CollaboratorUpdate, CollaboratorElement } from '../interfaces';
import { CollaboratorsService } from '../../services/collaborators/collaborators.service';

@Component({
  selector: 'mcrit-gestio-manage-project-collaborator-list',
  templateUrl: './collaborators-list.component.html',
  styleUrls: ['collaborators-list.component.css'],
  providers: [CollaboratorsService]
})


export class CollaboratorsListComponent implements OnInit {
  @Input('collaboratorList') collaboratorList: any;
  @Input() showAsyncProgress: boolean = false;
  @Input() idProjecte: number;
  @Input() idProposal: number;
  @Output() changeCollaborator: EventEmitter<CollaboratorUpdate> = new EventEmitter();

  public availableCollaborators: Array<CollaboratorElement> = [];
  public showEditor: boolean = false;
  public error: boolean = false;

  public newCollaboratorId: string = '';
  public newCollaboratorResp: boolean = false;
  public newCollaboratorTecResp: boolean = false;

  public setCoordinador(idContacte){
    this.collaboratorList.filter(item => item.idContacte !== idContacte).map(item => item.coordinador = false);
    let tipus = "project";
    if(this.router.url.indexOf("/proposalpe/") !== -1)tipus="proposalpe";//Detecta propostes / manifestacions d'interès per avisar del canvi de taula
    else if(this.router.url.indexOf("/proposal/") !== -1)tipus="proposal";
    this.collaboratorsService.setCoordinador((this.idProjecte?this.idProjecte:this.idProposal), idContacte, tipus).subscribe();
  }

  public setCoordinadorTecnic(idContacte){
    this.collaboratorList.filter(item => item.idContacte !== idContacte).map(item => item.coord_tecnic = false);
    let tipus = "project";
    if(this.router.url.indexOf("/proposalpe/") !== -1)tipus="proposalpe";//Detecta propostes / manifestacions d'interès per avisar del canvi de taula
    else if(this.router.url.indexOf("/proposal/") !== -1)tipus="proposal";
    this.collaboratorsService.setCoordinadorTecnic((this.idProjecte?this.idProjecte:this.idProposal), idContacte, tipus).subscribe();
  }

  public addCollaborator(): void {
    if (!this.newCollaboratorId || this.newCollaboratorId === '')return;
    const [collaboratorToAdd] = this.availableCollaborators
      .filter((item: CollaboratorElement): boolean => {
        return item.id === this.newCollaboratorId;
      });

    this.updateCollaborator(collaboratorToAdd, 'active');
    this.showEditor = false;
  }

  public openEditor(): void {
    this.showEditor = true;
    this.newCollaboratorId = '';
    this.newCollaboratorResp = false;
    this.newCollaboratorTecResp = false;

    this.filterCollaborators();
  }

  public closeEditor() {
    this.showEditor = false;
  }

  public updateCollaborator({id}: {id: string}, newStatus: 'active' | 'inactive'): void {
    this.changeCollaborator.emit({
      id: id,
      coordinador: this.newCollaboratorResp,
      coord_tecnic: this.newCollaboratorTecResp,
      status: newStatus
    });
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private collaboratorsService: CollaboratorsService, protected router: Router ){}

  private filterCollaborators() {
    if (!this.collaboratorList)return;

    const currentCollaborators = new Set(this.collaboratorList.map(item => item.id));
    this.collaboratorsService.get()
      .subscribe(
        list => {
          this.availableCollaborators = list.filter((item: CollaboratorElement): boolean => !currentCollaborators.has(item.id));
        },
        err => console.log(err)
      );
  }

  ngOnInit(){
    this.filterCollaborators();
  }
}
